export default __webpack_public_path__ + "imgs/zc_logo.3ded7b12.png";